import { HexString } from '@/types/cryptoGenerics'
import { useReadContract } from 'wagmi'
import useStakingContract from './contracts/staking'

export const useGetAVAXStake = (stakerAddr: HexString) => {
  const { abi, address: stakingAddress } = useStakingContract()

  const { data, isError, isLoading } = useReadContract({
    address: stakingAddress as `0x${string}`,
    abi,
    functionName: 'getAVAXStake',
    args: [stakerAddr],
  })

  return {
    data: data ? data : 0n,
    isLoading,
    isError,
  }
}

export const useGetGGPStake = (stakerAddr: HexString) => {
  const { abi, address } = useStakingContract()

  const { data, error, isError, isLoading } = useReadContract({
    address: address as `0x${string}`,
    abi,
    functionName: 'getGGPStake',
    args: [stakerAddr],
  })

  return {
    data: data ? data : 0n,
    isLoading,
    isError,
    error,
  }
}

export const useGetAVAXValidating = (stakerAddr: HexString) => {
  const { abi, address } = useStakingContract()

  const { data, error, isError, isLoading } = useReadContract({
    address: address as `0x${string}`,
    abi,
    functionName: 'getAVAXValidating',
    args: [stakerAddr],
  })

  return {
    data: data ? data : 0n,
    isLoading,
    isError,
    error,
  }
}

// getAVAXValidatingHighWater
export const useGetAVAXValidatingHighWater = (stakerAddr: HexString) => {
  const { abi, address } = useStakingContract()

  const { data, error, isError, isLoading } = useReadContract({
    address: address as `0x${string}`,
    abi,
    functionName: 'getAVAXValidatingHighWater',
    args: [stakerAddr],
  })

  return {
    data: data ? data : 0n,
    isLoading,
    isError,
    error,
  }
}

export const useGetStakerCount = () => {
  const { abi, address } = useStakingContract()

  return useReadContract({
    address: address as `0x${string}`,
    abi,
    functionName: 'getStakerCount',
  })
}

export const useGetGGPRewards = (stakerAddr: HexString) => {
  const { abi, address } = useStakingContract()

  return useReadContract({
    address: address as `0x${string}`,
    abi,
    functionName: 'getGGPRewards',
    args: [stakerAddr],
  })
}
